<template>
  <p class="pCss"></p>
</template>

<script>
export default {
  data() {
    return {
      events: ['mousemove', 'mousedown', 'click', 'scroll', 'keypress', 'load'],
      logoutTimer: null
    }
  },
  mounted() {
    this.events.forEach(function(event) {
      window.addEventListener(event, this.resetTimer)
    }, this)

    this.setTimers()
  },

  destroyed() {
    this.events.forEach(function(event) {
      window.removeEventListener(event, this.resetTimer)
    }, this)

    this.clearTimer()
    console.log('destroy')
  },
  methods: {
    setTimers() {
      this.logoutTimer = setTimeout(this.autoLogout, 10 * 60 * 1000)
    },
    autoLogout() {
      this.$router.replace('/')
    },
    resetTimer() {
      clearTimeout(this.logoutTimer)
      this.setTimers()
    },
    clearTimer() {
      clearTimeout(this.logoutTimer)
    }
  }
}
</script>

<style scoped>
.pCss {
  display: none;
}
</style>
